

















import { Component, Vue, Prop } from "vue-property-decorator";
import { ProjectModel } from "../models";
import dateFlip from "shared/filters/dateflip";

@Component({
  filters: {
    dateFlip,
  },
})
export default class ProjectTable extends Vue {
  @Prop({ required: true })
  projects!: ProjectModel[];

  headers = [
    { text: this.t("id"), value: "id" },
    { text: this.t("description"), value: "description" },
    { text: this.t("startDate"), value: "start_date" },
    { text: this.t("endDate"), value: "end_date" },
  ];

  pagination = {
    rowsPerPage: 15,
    descending: true,
  };

  rowsPerPageItems = [
    5,
    15,
    25,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
  ];

  private t(key: string): string {
    return this.$t("projects.table." + key).toString();
  }
}
